import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useVendorsStore} from "../../store/vendors.store";

export const useVendorProductOverview = () => {
    const setProductOverview = useVendorsStore((state) => state.setProductOverview);

    return useMutation(PartnerApi.vendorProductOverview, {
        onSuccess: (data) => {
            setProductOverview(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};